import Gauge from './Gauge';
export default Gauge;



// WEBPACK FOOTER //
// ./src/components/Gauge/index.js